import Viewer from './TagChoiceViewer';
import TagChoiceEditor from './TagChoiceEditor';

export const TagChoiceViewer = Viewer;
export default TagChoiceEditor;
